import styled from '@emotion/styled';
import { useEventLogging } from '@innovamat/event-logging';
import { Icon, Modal, Typography } from '@innovamat/glimmer-components';
import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

const DeleteAccountContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 48px;
`;

const Title = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const Content = styled.div`
  margin-top: 24px;
`;

function DeleteAccount(): JSX.Element {
  const { t } = useTranslation();
  const { setEventData } = useEventLogging();
  const [showConfirmation, setShowConfirmation] = useState(false);

  const handleDeleteAccount = (): void => {
    setEventData('user_deletion_email', {});
    setShowConfirmation(true);
  };

  return (
    <>
      <DeleteAccountContainer>
        <Typography.Subtitle2>
          {t('settings.delete_account.title')}
        </Typography.Subtitle2>
        <Typography.Body3>
          <Trans
            i18nKey="settings.delete_account.description"
            components={{
              a: (
                <a
                  onClick={handleDeleteAccount}
                  data-testid="deleteAccountButtonMySettings"
                />
              ),
            }}
          />
        </Typography.Body3>
      </DeleteAccountContainer>
      {showConfirmation && (
        <Modal
          modalWidth={'600px'}
          data-testid="deleteAccountModalMySettings"
          isOpen={showConfirmation}
          onClose={() => setShowConfirmation(false)}
          closeButton={'inner'}
          zIndex={39}
          buttons={[
            {
              children: t('common.accept'),
              onClick: () => setShowConfirmation(false),
              variant: 'accent',
            },
          ]}
        >
          <>
            <Title>
              <Icon icon={'MailIcon'} />
              <Typography.H3>
                {t('settings.delete_account.modal.title')}
              </Typography.H3>
            </Title>
            <Content>
              <Typography.Body2>
                <Trans
                  i18nKey="settings.delete_account.modal.description"
                  components={{
                    br: <br />,
                  }}
                />
              </Typography.Body2>
            </Content>
          </>
        </Modal>
      )}
    </>
  );
}

export { DeleteAccount };
